{
  "nl": {
    "locale_field": {
      "fallback_tooltip": "Wanneer er geen tekst ingevoerd is voor deze taal, wordt deze standaardtekst als terugvaloptie gebruikt.",
      "fill_missing": "Ontbrekende taal invullen ({count}) | Ontbrekende talen invullen ({count})",
      "fill_missing_budget_used": "Het AI-budget van deze maand is opgebruikt.",
      "fill_missing_done": "Ontbrekende talen ingevuld. Controleer de tekst voordat je opslaat.",
      "fill_missing_errors": {
        "budget_reached": "Het AI-budget van deze maand is opgebruikt. Neem contact op met Ziggu om het te verhogen.",
        "generic": "De talen konden niet ingevuld worden. Probeer het opnieuw.",
        "too_long": "Deze tekst is te lang om in één keer te vertalen."
      },
      "fill_missing_tooltip": "Vertaalt vanuit {language} met AI. Controleer de tekst voordat je opslaat.",
      "translated_in": "Vertaald in"
    }
  }
}
